import React from 'react';
import PropTypes from 'prop-types';

import { Badge } from '@openedx/paragon';

/**
 * Small presentational badge showing a product's access source (e.g. 'purchase', 'demo').
 */
export const AccessSourceBadge = ({ accessSource }) => {
  if (!accessSource) {
    return null;
  }
  return (
    <Badge variant="info" className="access-source-badge">
      {accessSource}
    </Badge>
  );
};

AccessSourceBadge.propTypes = {
  accessSource: PropTypes.string,
};

AccessSourceBadge.defaultProps = {
  accessSource: null,
};

export default AccessSourceBadge;
